<template lang="html">
  <div class="sign-in-mfa-setup-view view">
    <router-link class="back-button" :to="{ name: signInRouteName }">
      <v-icon>arrow_back</v-icon>{{ $t('back') }}
    </router-link>

    <h1>{{ $t('verifyMFACode.title') }}</h1>
    <div class="description">
      {{ $t('verifyMFACode.description') }}
    </div>

    <verify-mfa-code-form :submited="submited" @submit="submit" :error="errorMessage" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import { getSignInNextStepRoute, challengeVerifyMFACode } from '@/amplify/auth';
// import { authChallenges } from '@/amplify/constants';
import { authErrors } from '@/amplify/errors';
import { views, DEFAULT_LOGGED_IN_ROUTE } from '@/router/constants';

import VerifyMFACodeForm from '@/components/forms/VerifyMFACodeForm.vue';

export default {
  name: 'SignInVerifyMFACode',
  components: {
    'verify-mfa-code-form': VerifyMFACodeForm,
  },
  data() {
    return {
      errorMessage: '',
      submited: false,
    };
  },
  computed: {
    ...mapGetters(['authChallenge']),
    signInRouteName: () => views.SIGN_IN,
  },
  async mounted() {
    try {
      const nestAuthStepRouteName = getSignInNextStepRoute();
      if (nestAuthStepRouteName && nestAuthStepRouteName !== views.SIGN_IN_MFA_CODE) {
        await this.$router.push({ name: nestAuthStepRouteName });
        return;
      }
    } catch (e) {
      this.errorMessage = this.$t('error.general');
    }
  },
  methods: {
    async submit({ otpCode }) {
      this.submited = true;

      try {
        await challengeVerifyMFACode(otpCode);
        await this.$router.push({ name: DEFAULT_LOGGED_IN_ROUTE });
        this.submited = false;
      } catch (e) {
        const { code, message } = e || {};
        this.submited = false;

        if (code === authErrors.NOT_AUTHORIZED) {
          this.errorMessage = message;
        } else if (code === authErrors.CODE_MISMATCH) {
          this.errorMessage = this.$t('error.incorrectVerificationCode');
        } else if (code === authErrors.CHALLENGE_REQUIRED) {
          const nextRouteName = getSignInNextStepRoute();

          if (nextRouteName) {
            this.$router.push({ name: nextRouteName });
          } else {
            this.errorMessage = this.$t('error.general');
          }
        } else {
          this.errorMessage = this.$t('error.general');
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/design-system';

.sign-in-mfa-setup-view {
  max-width: 400px;
  padding-top: $space-15;
  position: relative;
  margin-right: auto;
  margin-left: auto;
}

.description {
  font-size: $font-size-base;
  line-height: 19px;
  color: $auth-text-secondary;
  margin-bottom: $space-8;
  text-align: center;
}

.back-button {
  position: absolute;
  top: $space-5;
  left: -50px;
  font-size: $font-size-sm;
  text-transform: uppercase;
  display: flex;
  flex-direction: row;
  align-items: center;

  .v-icon {
    color: $auth-brand;
    margin-right: $space-2;
  }
}

h1 {
  text-align: center;
  margin-bottom: 15px;
}
</style>
